import * as Maths3 from "oc-threejs/Maths3";
import * as Maths2 from "oc-threejs/Maths2";
import { Ray2 } from "oc-threejs/Maths2";
import React from "react";
import classnames from "classnames";
import * as Utils from "../../commons/Utils";
import { SVG } from "./SVG";
import { punkteZuLinie } from "./Zaunlinien";
import { CoordinateSystem } from "./CoordinateSystem";
import { Aufbau } from "../../arrangement/Aufbau";

import { Vector2 } from "three";

export function DragRulers({ cs, aufbau }: { cs: CoordinateSystem; aufbau: Aufbau }) {
  const agt = APP.arrangement;
  const grundriss = agt.grundriss;
  const grundrissSegmente = grundriss.kanten.map((k) => k.ecken.map((e) => e.punkt));
  const aufbauSegmente = agt.aufbauten.filter((a) => a !== aufbau).flatMap((a) => a.getSeitenV2());
  const segmente = [...grundrissSegmente, ...aufbauSegmente];

  // Schicke von dem Mittelpunkt jeder Seite des bewegten Aufbaus einen Ray in die Scene
  const rays = aufbau.getSeitenV2().map((seite) => {
    const origin = Maths2.middle(seite as [Vector2, Vector2]);
    const direction = Maths2.orthogonalLeft(Maths2.getDirection(...(seite as [Vector2, Vector2])));
    return new Ray2(origin, direction);
  });

  const toScreen = (p) => cs.pointToScreen(Maths3.v2To3xz(p));

  // Schneide die Rays mit allen Segmenten
  let rulers = [];
  for (const ray of rays) {
    const distances = segmente
      .map((segment) => ray.intersectsSegment(segment))
      .filter((p) => p != null)
      .map((p) => ray.origin.distanceTo(p));
    if (distances.length > 0) {
      const distance = Math.min(...distances);
      if (distance > 0.01 - Number.EPSILON) {
        rulers.push({
          points: [ray.at(0), ray.at(distance)].map(toScreen),
          middle: toScreen(ray.at(distance / 2)),
          distance,
        });
      }
    }
  }

  if (rulers.length == 0) {
    return null;
  }

  return (
    <div className="rulers grid-fullscreen no-pointer-events-tree fullsize">
      <SVG cs={cs}>
        {rulers.map(({ points }, index) => (
          <React.Fragment key={index}>
            <line {...punkteZuLinie(points)} className={classnames("svg-line-ruler-2")}></line>
          </React.Fragment>
        ))}
      </SVG>
      {rulers.map(({ distance, middle }, index) => (
        <div
          key={index}
          className="ruler-text"
          style={{ left: middle.x + "px", top: middle.y + "px" }}
        >
          <div className={classnames("ruler-text-inner")}>{Utils.formatM(distance, 2)}</div>
        </div>
      ))}
    </div>
  );
}
